module.exports = __webpack_public_path__ + "img/mobile-memory-game.602f83f.webp";